import { useCallback } from "react";
import { FeatureDc } from "@evergis/api";
import { deleteFeature as deleteFeatureResource } from "../../resources/deleteFeature";

import { useSGisLayer } from "../sgis/useSGisLayers";
import { useSGisLayerRedraw } from "../sgis/useSGisLayerRedraw";

export const useDeleteFeature = (layerName?: string, tableName?: string) => {
  const [mutation, { error, loading, data }] = deleteFeatureResource.use();
  const sgisLayer = useSGisLayer(layerName);
  const redrawLayer = useSGisLayerRedraw(sgisLayer);

  const deleteFeature = useCallback(
    async (feature: FeatureDc) => {
      if (!feature.id || !layerName) {
        return;
      }

      await mutation({ input: { name: layerName, id: feature.id, tableName } });

      redrawLayer();
    },
    [layerName, mutation, redrawLayer, tableName],
  );

  return [deleteFeature, { error, loading, data }] as const;
};
